import { Action, Dispatch, Middleware, Store } from 'redux'

export interface ISideEffect<TState> {
  handle: (action: Action, previous: TState, current: TState) => void
}

export interface ISideEffectConstructor<TState> {
  (store: Store<TState>): ISideEffect<TState>
}

export function createSideEffect<TState>(sideEffectConstructor: ISideEffectConstructor<TState>): Middleware {
  return (store: Store<TState>) => (next: Dispatch): Dispatch => {
    const sideEffect = sideEffectConstructor(store)
    return <A extends Action>(action: A) => {
      const previous = store.getState()
      const result = next(action)
      const current = store.getState()
      sideEffect.handle(action, previous, current)
      return result
    }
  }
}
